import React, { JSX, useState } from "react";
import { Outlet } from "react-router";
import {
    CourseSearchContext,
    CourseSearchCriteria,
    defaultCourseSearchCriteria,
} from "utilities/contexts/search/course/course-search-context";

interface AdminCourseLayoutProps {}

const AdminCourseLayout: React.FC<AdminCourseLayoutProps> = (): JSX.Element => {
    const [courseSearchCriteria, setCourseSearchCriteria] = useState<CourseSearchCriteria>(
        defaultCourseSearchCriteria
    );

    return (
        <CourseSearchContext.Provider
            value={{ initialCriteria: courseSearchCriteria, setCriteria: setCourseSearchCriteria }}>
            <Outlet />
        </CourseSearchContext.Provider>
    );
};

export { AdminCourseLayout };
